import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { isValidElement, cloneElement, Children } from 'react';
import PropTypes from 'prop-types';
import UITabs from 'UIComponents/nav/UITabs';
import { useLocation } from 'react-router-dom';
import { matchPath } from 'react-router-dom';
import { cloneDefaultProps, clonePropTypes } from './internal/utils';

const UIRouterTabs = props => {
  const {
    children
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["children"]);

  const location = useLocation();
  let selected = undefined;
  const tabs = Children.map(children, (element, i) => {
    if (! /*#__PURE__*/isValidElement(element)) {
      return null;
    } else if (!selected) {
      const {
        to,
        exact = false,
        strict = false
      } = element.props;
      const path = typeof to === 'object' ? to.pathname : to;

      if (matchPath(location.pathname, {
        path,
        exact,
        strict
      })) {
        selected = `${i}`;
      }
    }

    return /*#__PURE__*/cloneElement(element, {
      tabId: `${i}`
    });
  });
  return /*#__PURE__*/_jsx(UITabs, Object.assign({}, rest, {
    selected: selected,
    children: tabs
  }));
};

const _clonePropTypes = clonePropTypes(UITabs),
      sanitizedUITabsPropTypes = _objectWithoutPropertiesLoose(_clonePropTypes, ["selected"]);

UIRouterTabs.propTypes = Object.assign({}, sanitizedUITabsPropTypes, {
  children: PropTypes.node.isRequired
});
UIRouterTabs.defaultProps = cloneDefaultProps(UITabs);
export default UIRouterTabs;